import { Prog } from "./Prog";
import { is_on_mobile } from "../app";

export class ToggleThemes {
  $create() {
    gl_api.getProg().then((prog) => {
      this.movies_event = new Prog(prog);
      const events = this.movies_event.getAllEvents();


      // $("body").removeClass("dark-theme");
      // $("body").addClass("light-theme");
      // var theme = "light";
      // localStorage.setItem("lightTheme", "enabled");
      // init_css_vars(theme == "light" ? false : true) // config.js
      // return;

      this.toggleThemes(events);
    });
  }

  toggleThemes(events) {
    const containerFluid = $(".container-fluid");
    const isLightThemeStored = localStorage.getItem("lightTheme") === "enabled";
    const imgUrlForDarkTheme = gl_config.theme.dark_bg_image.url;
    const imgUrlForLightTheme = gl_config.theme.light_bg_image.url;
    let theme = "";

    const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
    prefersDarkScheme.addEventListener("change", null);
    const prefersLightScheme = window.matchMedia(
      "(prefers-color-scheme: light)"
    );

    prefersLightScheme.addEventListener("change", (event) => {
      console.log("theme has change", event)
      if (event.matches) {
        theme = "light";
        $("body").removeClass("dark-theme");
        $("body").addClass("light-theme");
        $("#hero-img").attr({ src: imgUrlForLightTheme });
        // $("#shortly-hero-img").attr({ src: imgUrlForLightTheme });
        localStorage.setItem("lightTheme", "enabled");
      } else {
        theme = "dark";
        $("body").removeClass("light-theme");
        $("body").addClass("dark-theme");
        $("#hero-img").attr({ src: imgUrlForDarkTheme });
        // $("#shortly-hero-img").attr({ src: imgUrlForDarkTheme });
        // $("#shortly-hero-img").attr({ src: imgUrlForDarkTheme });
        localStorage.setItem("lightTheme", "disabled");
      }
      // getHeroData(events, theme);

      window.location.reload()
    });

    if (!isLightThemeStored && prefersLightScheme.matches) {
      $("body").removeClass("dark-theme");
      $("body").addClass("light-theme");
      theme = "light";
      $("#hero-img").attr({ src: imgUrlForLightTheme });
      // $("#shortly-hero-img").attr({ src: imgUrlForLightTheme });
      localStorage.setItem("lightTheme", "enabled");
    } else {
      if (isLightThemeStored) {
        theme = "light";
        $("body").removeClass("dark-theme");
        $("body").addClass("light-theme");
        $("#hero-img").attr({ src: imgUrlForLightTheme });
        // $("#shortly-hero-img").attr({ src: imgUrlForLightTheme });
        localStorage.setItem("lightTheme", "enabled");
      } else {
        theme = "dark";
        $("body").removeClass("light-theme");
        $("body").addClass("dark-theme");
        $("#hero-img").attr({ src: imgUrlForDarkTheme });
        // $("#shortly-hero-img").attr({ src: imgUrlForDarkTheme });
        localStorage.setItem("lightTheme", "disabled");
      }
    }

    init_css_vars(theme == "light" ? false : true) // config.js
  }
}
